import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  SecondaryCallToActionButtonStyle,
  backgroundColor,
  outlineStyle,
  secondaryCallToActionButtonStyle,
  //   defaultBackgroundColor,
  //   defaultTextColor,
  textColor,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/constant';

import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';
import { sectionProps } from 'src/tools/constant';

import ColorPicker from 'src/components/Modules-revamp/ColorPicker';

const SCTAB = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;

  return (
    <Wrapper id={SecondaryCallToActionButtonStyle} breakpoint={breakpoint}>
      <BlockTitle
        id={SecondaryCallToActionButtonStyle}
        title={getI18n(
          'salesChannelContent.index.secondaryCallToActionButtonStyle',
        )}
        breakpoint={breakpoint}
        onReset={
          () => {
            return;
          } // handleOnSectionReset(item?.fields, breakpoint)
        }
        onCopy={
          () => {
            return;
          } // handleOnSectionCopy(item?.fields, breakpoint)}
        }
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />
      <Section {...sectionProps}>
        <ItemWrapper title={getI18n('salesChannelContent.index.outlineColour')}>
          <Field
            name={[
              secondaryCallToActionButtonStyle,
              outlineStyle,
              backgroundColor,
            ]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.textColour')}>
          <Field
            name={[secondaryCallToActionButtonStyle, outlineStyle, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default SCTAB;
